module.exports = __webpack_public_path__ + "img/forest.4dfdd0f3.png";